import { toNumberOrZero } from '~/utils/functions';
import { Produto } from '../../protocols';

const toArray = <T>(value: T | T[] | null | undefined): T[] =>
  value == null ? [] : Array.isArray(value) ? value : [value];

export const aplicarTratativaIbsCbs = (p: Produto[]): Produto[] => {
  const produtosArray = toArray(p);

  return produtosArray.map((produto) => {
    const quantidade = toNumberOrZero(produto.qtd_devolucao);
    const codIbsCbsNumber = toNumberOrZero(produto.cod_ibs_cbs);

    if (codIbsCbsNumber > 0) {
      return {
        ...produto,
        cod_ibs_cbs: codIbsCbsNumber,
        cst_ibs_cbs: produto.cst_ibs_cbs ?? '',
        des_classif_trib_ibs_cbs: produto.des_classif_trib_ibs_cbs ?? '',
        per_aliq_cbs: toNumberOrZero(produto.per_aliq_cbs),
        per_red_cbs: toNumberOrZero(produto.per_red_cbs),
        per_aliq_ibs_est: toNumberOrZero(produto.per_aliq_ibs_est),
        per_aliq_ibs_mun: toNumberOrZero(produto.per_aliq_ibs_mun),
        per_red_ibs: toNumberOrZero(produto.per_red_ibs),
        val_bc_ibs_cbs: toNumberOrZero(produto.val_bc_ibs_cbs) * quantidade,
      };
    }

    return {
      ...produto,
      cod_ibs_cbs: 0,
      per_aliq_cbs: 0,
      per_red_cbs: 0,
      val_red_social: 0,
      per_aliq_ibs_est: 0,
      per_aliq_ibs_mun: 0,
      per_red_ibs: 0,
      cst_ibs_cbs: '',
      des_classif_trib_ibs_cbs: '',
    };
  });
};
